<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title" translate>CREATE_QUOTATION</h4>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-12">
      <form [formGroup]="nameForm">
        <div class="form-group">
          <label for="name" class="control-label" translate>NAME</label>
          <input
            class="form-control"
            formControlName="name"
            type="text"
            name="name"
            id="name"
            [(ngModel)]="name"
            ngbAutofocus
            required
          />
          <div
            *ngIf="nameForm.controls.name.errors?.required && nameForm.controls.name.touched"
            class="text-danger"
            translate
          >
            NAME_IS_REQUIRED
          </div>
        </div>
      </form>
    </div>
    <div class="col-12 col-md-6">
      <lib-gung-text-input gungTranslate="CUSTOMER" [(ngModel)]="customerName"></lib-gung-text-input>
      <lib-gung-text-input gungTranslate="YOUR_REFERENCE" [(ngModel)]="yourReference"></lib-gung-text-input>
      <lib-gung-text-input gungTranslate="PAYMENT_TERMS" [(ngModel)]="paymentTerms"></lib-gung-text-input>
      <!-- <lib-gung-text-input gungTranslate="ADDRESS1" [(ngModel)]="address1"></lib-gung-text-input> -->
      <!--  <lib-gung-text-input gungTranslate="NOTES" [(ngModel)]="notes"></lib-gung-text-input> -->
    </div>
    <div class="col-12 col-md-6">
      <div class="row">
        <div class="col-md-6">
          <label translate>DATE</label>
          <div class="input-group">
            <input
              class="form-control"
              placeholder="yyyy-mm-dd"
              name="dp"
              ngbDatepicker
              #d1="ngbDatepicker"
              [(ngModel)]="date"
            />
            <div class="input-group-append">
              <button class="btn btn-outline-secondary calendar" (click)="d1.toggle()" type="button">
                <i class="fal fa-calendar-alt"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <label translate>EXPIRE_DATE</label>
          <div class="input-group">
            <input
              class="form-control"
              placeholder="yyyy-mm-dd"
              name="dp"
              ngbDatepicker
              #d2="ngbDatepicker"
              [(ngModel)]="expireDate"
            />
            <div class="input-group-append">
              <button class="btn btn-outline-secondary calendar" (click)="d2.toggle()" type="button">
                <i class="fal fa-calendar-alt"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <lib-gung-text-input gungTranslate="OUR_REFERENCE" [(ngModel)]="ourReference"></lib-gung-text-input>
      <lib-gung-text-input gungTranslate="DELIVERY_TERMS" [(ngModel)]="deliveryTerms"></lib-gung-text-input>
    </div>
    <div class="col-12">
      <div class="form-group">
        <label for="description" lass="control-label" translate>NOTES</label>
        <textarea
          class="form-control"
          type="text"
          name="description"
          id="description"
          [(ngModel)]="description"
        ></textarea>
      </div>
    </div>
    @if (isAdmin && !isJosam) {
      <div class="col-12">
        <lib-gung-checkbox-input-horizontal gungTranslate="SHOW_INCLUDED_ITEMS" [(ngModel)]="showIncludedItems" />
        @if (showIncludedItems) {
          <lib-gung-checkbox-input-horizontal
            gungTranslate="SHOW_IMAGES_FOR_INCLUDED_ITEMS"
            [(ngModel)]="showImagesForIncludedItems"
          />
        }
      </div>
    }
  </div>
</div>

<div class="modal-footer">
  @if (showIncludedItems) {
    <button
      type="button"
      class="btn btn-primary ml-auto"
      [disabled]="nameForm.controls.name.invalid"
      (click)="saveCart()"
      translate
    >
      SAVE_AND_EMAIL_QUOTATION
    </button>
  }
  @if (!showIncludedItems) {
    <button
      type="button"
      class="btn btn-primary ml-auto"
      [disabled]="nameForm.controls.name.invalid"
      (click)="saveCart()"
      translate
    >
      SAVE_AND_DOWNLOAD_QUOTATION
    </button>
  }
</div>
